// This page is for register secret question - answer After sign up using
attorney number and email.
<template>
  <div class="flex items-center min-h-screen w-full">
    <div
      class="w-full bg-white rounded shadow-lg p-8 m-4 md:max-w-md md:mx-auto"
    >
      <div class="md:flex w-full">
        <div class="w-full py-10 px-5">
          <div class="flex items-center">
            <svg
              class="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
              ></path>
            </svg>
            <div class="text-right text-xl cobalt-text-color">
              Register Account
            </div>
          </div>
          <form class="mt-4 space-y-6" @submit.prevent="register" novalidate>
            <div class="rounded-sm">
                 <div class="flex flex-col">
                <text-input
                id="username"
                  label="Username"
                  :class="{ 'border-red-400': v$.form.username.$error }"
                  v-bind:value="form.username"
                  @blur="v$.form.username.$touch()"
                  @change="checkValidUsername($event.target.value)"
                  v-on:keyup="form.username = $event.target['value']"
                ></text-input>
                <div
                  class="text-red-600 mt-1 text-sm"
                  v-for="(error, index) in v$.form.username.$errors"
                  :key="index"
                >
                  <div v-if="error.$validator == 'required'">
                    {{ error.$message }}
                  </div>
                  <div v-if="error.$validator == 'minLength'">
                    must be at least 8 characters
                  </div>
                  <div v-if="error.$validator == 'alphaNum'">
                    must be only alphabetics and numeric
                  </div>
                </div>
                <div
                  v-if="is_duplicate_username && !v$.form.username.$error"
                  class="text-red-600 mt-1 text-sm"
                >
                  <div>UserName already taken <i class="fa fa-times"></i></div>
                </div>
                <div
                  v-if="
                    !is_duplicate_username &&
                      !v$.form.username.$error &&
                      form.username != '' &&
                      is_duplicate_username != null
                  "
                  class="text-green-600 mt-1 text-sm"
                >
                  <div>UserName Available <i class="fa fa-check"></i></div>
                </div>
              </div>
              <div class="flex flex-col mt-2">
                <text-input
                id="password"
                  label="Password"
                  :type="show ? 'password' : 'text'"
                  showIcon="true"
                  showIcon1="true"
                  @showHide="show = !show"
                  :class="{ 'border-red-400': v$.form.password.$error }"
                  v-bind:value="form.password"
                  @blur="v$.form.password.$touch()"
                  helptext="Must be at least 8 characters and contain a lowercase & uppercase character with a special character and a number."
                  v-on:keyup="form.password = $event.target['value']"
                ></text-input>

                <div
                  class="text-red-600 mt-1 text-sm"
                  v-for="(error, index) in v$.form.password.$errors"
                  :key="index"
                >
                  <div v-if="error.$validator == 'required'">
                    {{ error.$message }}
                  </div>
                  <div v-if="error.$validator == 'password'">
                    Please enter valid password
                  </div>
                </div>
              </div>
              <div class="flex flex-col mt-2">
                <text-input
                id="confirm_password"
                  label="Confirm Password"
                  :type="show1 ? 'password' : 'text'"
                  showIcon="true"
                  showIcon1="true"
                  @showHide="show1 = !show1"
                  @blur="v$.form.confirm_password.$touch()"
                  :class="{ 'border-red-400': v$.form.confirm_password.$error }"
                  v-bind:value="form.confirm_password"
                  v-on:keyup="form.confirm_password = $event.target['value']"
                ></text-input>
                <div
                  class="text-red-600 mt-1 text-sm"
                  v-for="(error, index) in v$.form.confirm_password.$errors"
                  :key="index"
                >
                  <div v-if="error.$validator == 'required'">
                    {{ error.$message }}
                  </div>
                  <div v-if="error.$validator == 'sameAsPassword'">
                    Passwords must match
                  </div>
                </div>
              </div>
              <div class="flex flex-col mt-2">
                <label
                  class="block text-sm font-medium text-gray-900"
                  for="date_admitted_to_bar"
                  >Secret Question
                </label>
                <AutoComplete
                  class="h-10 pt-1"
                  forceSelection
                  :dropdown="true"
                  readonly
                  :class="{ 'border-red-400': v$.form.secret_question.$error }"
                  v-model="form.secret_question"
                  :suggestions="secret_questions"
                  @complete="searchAutocomplete($event, 'secret_question')"
                  field="name"
                />
                <div
                  class="text-red-600 mt-1 text-sm"
                  v-for="(error, index) in v$.form.secret_question.$errors"
                  :key="index"
                >
                  <div v-if="error.$validator == 'required'">
                    {{ error.$message }}
                  </div>
                </div>
              </div>
              <div class="flex flex-col mt-2">
                <text-input
                id="secret_answer"
                  label="Secret Answer"
                  :class="{ 'border-red-400': v$.form.secret_answer.$error }"
                  v-bind:value="form.secret_answer"
                  @blur="v$.form.secret_answer.$touch()"
                  v-on:keyup="form.secret_answer = $event.target['value']"
                ></text-input>
                <div
                  class="text-red-600 mt-1 text-sm"
                  v-for="(error, index) in v$.form.secret_answer.$errors"
                  :key="index"
                >
                  <div v-if="error.$validator == 'required'">
                    {{ error.$message }}
                  </div>
                </div>
              </div>
           
            </div>
            <div>
              <button
                id="register"
                type="submit"
                class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white cobalt-button-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-50"
              >
                <span class="absolute left-0 inset-y-0 flex items-center pl-3">
                  <svg
                    class="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                    ></path>
                  </svg>
                </span>
                Register
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TextInput from "../Layout/Form/TextInput.vue";
import useVuelidate from "@vuelidate/core";
import { required, minLength, sameAs, alphaNum } from "@vuelidate/validators";
import { helpers } from "vuelidate/lib/validators";
const password = helpers.regex(
  "password",
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/
);
import { mapState } from "vuex";
export default {
  name: "Register",
  components: {
    TextInput,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  computed: mapState(["att_user", "is_duplicate_username"]),
  data: function() {
    return {
      show: true,
      secret_questions: [
        { id: 0, name: "In what town or city were you born?" },
        { id: 1, name: "What was your high school mascot?" },
        { id: 2, name: "What is your mother’s maiden name?" },
        { id: 3, name: "What is your father’s middle name?" },
        {
          id: 4,
          name: "In what city or town did you meet your spouse/partner?",
        },
      ],
      show1: true,
      form: {},
    };
  },
  validations() {
    return {
      form: {
        secret_question: {
          required,
        },
        username: {
          required,
          minLength: minLength(8),
          alphaNum,
        },
        secret_answer: {
          required,
        },
        password: {
          required,
          password,
        },
        confirm_password: {
          required,
          sameAsPassword: sameAs(this.form.password),
        },
      },
    };
  },
  mounted() {
    // If attorney not signup using attorney number and email, then it will redirect to signup page, beacuse without that they can't register passowrd and secret answers
    if(this.att_user==null || this.att_user==""){
      this.$toast.error("Please SignUp first!");
      this.$router.push("/login");
    }
  },
  created() {
    this.$store.watch(
      () => this.$store.state.att_user,
      (value) => {
        if (value != null) {
          localStorage.setItem("att_data", JSON.stringify(value));
          this.$toast.success(
            "Password registered successfully, You can login now!"
          );
          this.$router.push("/login");
        }
      }
    );
    this.$store.watch(
      () => this.$store.state.errors,
      (value) => {
        if (value.length != 0) {
          this.$toast.error("Something went wrong, please try again!");
        }
      }
    );
  },
  methods: {
    checkValidUsername: function(value) {
      this.$store.dispatch("checkValidUsername", { username: value });
    },
    register: function() {
      this.v$.form.$touch(this.v$.form.errors);
      if (
        this.v$.form.$pending ||
        this.v$.form.$error ||
        this.is_duplicate_username
      )
        return;
      this.form.id = this.att_user["data"].id;
      this.$store.dispatch("setupAttorney", this.form);
    },
    searchAutocomplete: function(event, field) {
      if (field == "secret_question") {
        if (!event.query.trim().length) {
          this.secret_questions = [...this.secret_questions];
        } else {
          this.secret_questions = this.secret_questions.filter((item) => {
            return item.name
              .toLowerCase()
              .startsWith(event.query.toLowerCase());
          });
        }
      }
    },
  },
};
</script>
